var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canInstall && _vm.show && _vm.shop
    ? _c(
        "div",
        {
          staticClass: "bg-grey7 p-5 flex-between-center shadow-3 w-100",
          class: {
            "pos-fixed bottom-0 zindex-100": !_vm.UiService.isMobileView,
          },
        },
        [
          _vm.shop
            ? _c("div", { staticClass: "flex-start-center" }, [
                _c("img", {
                  staticClass: "bg-grey1 size-wh-45 radius-8 m-5",
                  attrs: {
                    width: "125",
                    height: "125",
                    src: _vm.UrlService.imagePath(
                      _vm.shop.ShopId,
                      _vm.shop.Logo
                    ),
                    alt: _vm.shop.DefaultName,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "color-grey1" }, [
                  _c("h3", { staticClass: "fsize-18 text-bold mx-5 my-0" }, [
                    _vm._v(_vm._s(_vm.shop.DefaultName)),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "fsize-12 mx-5 my-0" }, [
                    _vm._v(_vm._s(_vm.shop.DefaultDescription)),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "color-white bg-blueD mx-10 py-5 px-15 radius-20 bg-hover-white hover-blueD fsize-16 inherit",
                    on: {
                      click: function ($event) {
                        return _vm.InstallerService.install()
                      },
                    },
                  },
                  [
                    _vm._v("\n                Installer "),
                    _vm.admin
                      ? _c("span", [
                          _vm._v("Admin " + _vm._s(_vm.shop.DefaultName)),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "inherit hover-ko p-5 mx-5",
              on: {
                click: function ($event) {
                  return _vm.hideBanner()
                },
              },
            },
            [_c("i", { staticClass: "fie-icon_close fsize-20" })]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }